import React from 'react';
import {IMyCoupons} from "../interfaces";

interface IMyCouponItemData {
    itemData: IMyCoupons
}
/**
 * MyCouponSkuData
 */
const MyCouponSkuData = (props:IMyCouponItemData) => {
    return (
            <li className="sku-data">

                <div className="">{props.itemData.skuName}{ props.itemData.skuDurationText ? <span>: {props.itemData.skuDurationText}</span> : ""}</div>
            </li>
    )
};

export default  MyCouponSkuData;